import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/jomtrace.jpg";
import suicide from "../../Assets/Projects/suicide.png";
import honeypot from "../../Assets/Projects/honeypot-01.png";
import typing from "../../Assets/Projects/typing-01.png";
import jomtrace from "../../Assets/Projects/Jomtrace-01.png";
import gotcha from "../../Assets/Projects/gotcha-01.png";
import mergeSort from "../../Assets/Projects/mergeSort-01.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Projects </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jomtrace}
              isBlog={false}
              title="Jomtrace Contact Tracing App"
              description="JomTrace is an innovative project which focuses on automated pandemic contact tracing using the Bluetooth technology to monitor pandemic. Our main motive is to break the chain of spread by sending automated notifications to users who might be exposed to Covid-19 and to ensure users to follow the SOP by sending distance alerts. This project is aimed to keep our USM community safe in this pandemic."
              ghLink="https://github.com/Jeevittan/BluetoothTracingApp"
              demoLink="https://install.appcenter.ms/users/sharvin.kogilavanan-gmail.com/apps/jom-trace/distribution_groups/public"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={honeypot}
              isBlog={false}
              title="Web Based Honeypot IDS"
              description="Honeypot IDS is a system which detects and prevents attackers from intruding to our system by trapping them with in a clone website which is called as a honeypot. This system also sends realtime alert upon detected intrusion activities."
              ghLink="https://github.com/Jeevittan/Web-IDS-Honeypot-forked-"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={typing}
              isBlog={false}
              title="Typing.io"
              description="A simple online typing game which was created during my first internship inteview with my pair. Have fun playing hehe :)"
              ghLink="https://github.com/Jeevittan/TypingGame"
              demoLink="https://jeevittan.github.io/TypingGame/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gotcha}
              isBlog={false}
              title="Gotcha"
              description="Gotcha is an app that include features of password complexity, one-time password (OTP) verification, hashing, salting and etc. is proposed. In this app, our focus is on working towards better password security"
              ghLink="https://github.com/Jeevittan/Password-Authentication"
              demoLink="https://youtu.be/NyCw3x5pBX4"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mergeSort}
              isBlog={false}
              title="Analysis of Merge Sort using Sequential and Parallel Method"
              description="This is an ongoing analysis of Merge Sort using 2 approaches which is Sequential and Parallel. The aim of this program is to find how each methods supports teh scalability, speedup and efficiency. This program is done completely on Python using the multiprocessing library for parallel execution."
              ghLink="https://github.com/Jeevittan/MergeSort_Seq_Parl"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
